import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';

@Component({
  selector: 'app-not-owner',
  templateUrl: './not-owner.component.html',
  styleUrls: ['./not-owner.component.scss']
})
export class NotOwnerComponent implements OnInit {

  constructor(private location: Location) {
  }

  ngOnInit() {
  }

  back() {
    this.location.back();
  }
}
